import React from "react";
import styled from "styled-components";
import {
  CircularProgress,
  FlatButton,
  RaisedButton,
  TextField
} from "material-ui";
import request from "../../../config/axios-config";
import * as ContractsService from "../../../services/contract-service";
import ContractsDialog from "./ContractsDialog";
import ContractsTable from "./ContractsTable";
import { Constants } from "../../../constants";
import * as fileSaver from "file-saver";
import * as validator from "../../../general/validators/validator";
import { connect } from "react-redux";
import * as ErrorAction from "../../../redux/action/error-action";

const Container = styled.div``;

const YearContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  width: 100%;
`;

const YearSearchContainer = styled.div`
  display: flex;
  align-items: center;
`;

const LoadingContainer = styled.div`
  text-align: center;
`;

class ContractsPage extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: false,
      showAddDialog: false,
      showEditDialog: false,
      data: [],
      showEditData: null,
      downloadingReport: false,
      year: new Date().getFullYear()
    };
  }

  componentDidMount() {
    this._fetchData();
  }

  _fetchData = () => {
    this.setState({
      loading: true
    });
    ContractsService.getAllContracts(this.state.year)
      .then(response => {
        console.log("lucitest response", response);
        this.setState({
          data: response.data,
          loading: false
        });
      })
      .catch(err => {
        console.log("lucitest err", err);

        this.setState({
          loading: false
        });
      });
  };

  onExcelDownloadClick = () => {
    const url =
      Constants.SERVER_ENDPOINT +
      "/document/contracts/excel?year=" +
      this.state.year;
    this.setState({
      downloadingReport: true
    });
    this.props.hideError();
    request({
      url: url,
      method: "GET",
      responseType: "blob"
    })
      .then(response => {
        const suggestedFileName = response.headers.filename;
        const effectiveFileName =
          suggestedFileName === undefined
            ? "Contracte raport.xlsx"
            : suggestedFileName;
        fileSaver.saveAs(response.data, effectiveFileName);

        this.setState({
          downloadingReport: false
        });
      })
      .catch(response => {
        this.setState({
          downloadingReport: false
        });
        this.props.showError(
          "Descarcarea documentului a esuat! Va rog reincercati!"
        );
      });
  };

  render() {
    const {
      loading,
      showAddDialog,
      showEditDialog,
      data,
      year,
      showEditData,
      downloadingReport
    } = this.state;
    return (
      <Container>
        {(showAddDialog || showEditDialog) && (
          <ContractsDialog
            title={showEditDialog ? "Editeaza contract" : "Adauga contract"}
            data={showEditData}
            onCancel={shouldRefresh => {
              this.setState({
                showAddDialog: false,
                showEditDialog: false,
                showEditData: null
              });
              this.props.onDialogVisible(false);
              if (shouldRefresh) {
                this._fetchData();
              }
            }}
          />
        )}

        <YearContainer>
          <YearSearchContainer>
            <TextField
              style={{ marginLeft: 24 }}
              floatingLabelText="Anul"
              type={"number"}
              value={year}
              onChange={e => {
                this.setState({ year: e.target.value });
              }}
            />

            <FlatButton
              style={{ marginLeft: 24 }}
              primary
              label={"Cauta"}
              onClick={() => this._fetchData()}
            />
            <FlatButton
              style={{
                marginRight: "20px",
                display: "inline-block",
                verticalAlign: "middle"
              }}
              primary
              label={"Descarca raportul"}
              onClick={() => this.onExcelDownloadClick()}
            />

            {downloadingReport && <CircularProgress />}
          </YearSearchContainer>

          <RaisedButton
            style={{ marginRight: 24 }}
            primary
            label={"Adauga"}
            onClick={() => {
              this.setState({
                showAddDialog: true
              });
              this.props.onDialogVisible(true);
            }}
          />
        </YearContainer>

        {loading && (
          <LoadingContainer>
            <CircularProgress />
          </LoadingContainer>
        )}

        {data && data.length > 0 ? (
          <ContractsTable
            data={data}
            onDetailsClicked={el => {
              this.props.onDialogVisible(true);
              this.setState({
                showEditDialog: true,
                showEditData: el
              });
            }}
          />
        ) : (
          !loading && <h3>Nu exista contracte pentru perioada selectata</h3>
        )}
      </Container>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    user: state.login.user
  };
}

function mapDispatchToProps(dispatch) {
  return {
    showError: text => dispatch(ErrorAction.showError(text)),
    hideError: () => dispatch(ErrorAction.hideError())
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ContractsPage);
